module.exports = __webpack_public_path__ + "static/media/IconInfo.57fa8df6.svg";